import * as Type from './actionsTypes';

const loadProgramacaoDiaria = filtro => ({ type: Type.FETCH_PROGRAMACAO_DIARIAS, filtro });

const deleteProgramacaoDiaria = (id, callback) => ({ type: Type.DELETE_PROGRAMACAO_DIARIA, id, callback });

const saveProgramacaoDiaria = (data, callback) => ({ type: Type.SAVE_PROGRAMACAO_DIARIA, data, callback });

const updateProgramacaoDiaria = (data, callback) => ({ type: Type.UPDATE_PROGRAMACAO_DIARIA, data, callback });

const findProgramacaoDiariaById = id => ({ type: Type.PROGRAMACAO_DIARIA_FIND_BY_ID, id });

const findOptions = grupo => ({ type: Type.PROGRAMACAO_DIARIA_FIND_OPTIONS, grupo });

const validateProgramacaoDiaria = (id, validate) => ({ type: Type.PROGRAMACAO_DIARIA_VALIDATE_BY_ID, id, validate });

const exportProgramacaoDiaria = (filter, callbackAfterSave) => ({ type: Type.PROGRAMACAO_DIARIA_EXPORT, filter, callbackAfterSave });

export {
  loadProgramacaoDiaria,
  deleteProgramacaoDiaria,
  saveProgramacaoDiaria,
  updateProgramacaoDiaria,
  findProgramacaoDiariaById,
  findOptions,
  validateProgramacaoDiaria,
  exportProgramacaoDiaria
}
